/* eslint-disable max-len */
// Imported and modified from http://www.bnm.gov.my/index.php?ch=en_announcement&pg=en_announcement&ac=478
const MY_BANKS = [
  { value: 'Aeon Bank', text: 'Aeon Bank' },
  { value: 'Affin Bank Berhad', text: 'Affin Bank Berhad' },
  { value: 'Affin Islamic Bank Berhad', text: 'Affin Islamic Bank Berhad' },
  { value: 'Agro Bank Malaysia', text: 'Agro Bank Malaysia' },
  { value: 'Al Rajhi Bank', text: 'Al Rajhi Bank' },
  // { value: 'Alkhair International Islamic Bank Bhd', text: 'Alkhair International Islamic Bank Bhd', disabled: true },
  { value: 'Alliance Bank Malaysia Berhad', text: 'Alliance Bank Malaysia Berhad' },
  { value: 'Alliance Islamic Bank Berhad', text: 'Alliance Islamic Bank Berhad' },
  { value: 'AmBank (M) Berhad', text: 'AmBank (M) Berhad' },
  { value: 'AmBank Islamic Berhad', text: 'AmBank Islamic Berhad' },
  // { value: 'Asia Offshore Finance Agency', text: 'Asia Offshore Finance Agency', disabled: true },
  { value: 'Bangkok Bank Berhad', text: 'Bangkok Bank Berhad' },
  { value: 'Bank Islam Malaysia', text: 'Bank Islam Malaysia' },
  { value: 'Bank Muamalat Malaysia', text: 'Bank Muamalat Malaysia' },
  { value: 'Bank of America Malaysia Berhad', text: 'Bank of America Malaysia Berhad' },
  { value: 'Bank of China (Malaysia) Berhad', text: 'Bank of China (Malaysia) Berhad' },
  { value: 'Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad', text: 'Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad' },
  { value: 'Bank Perusahaan Kecil & Sederhana Berhad ((Small Medium Enterprise) SME Bank Berhad)', text: 'Bank Perusahaan Kecil & Sederhana Berhad ((Small Medium Enterprise) SME Bank Berhad)' },
  { value: 'Bank Rakyat', text: 'Bank Rakyat' },
  { value: 'Bank Simpanan Nasional', text: 'Bank Simpanan Nasional' },
  { value: 'BNP Paribas Malaysia Berhad', text: 'BNP Paribas Malaysia Berhad' },
  { value: 'Boost Bank', text: 'Boost Bank' },
  { value: 'China Construction Bank (Malaysia) Berhad[2]', text: 'China Construction Bank (Malaysia) Berhad[2]' },
  { value: 'CIMB Bank Berhad', text: 'CIMB Bank Berhad' },
  { value: 'CIMB Islamic Bank Berhad', text: 'CIMB Islamic Bank Berhad' },
  { value: 'Citibank Berhad', text: 'Citibank Berhad' },
  { value: 'Deutsche Bank (Malaysia) Berhad', text: 'Deutsche Bank (Malaysia) Berhad' },
  { value: 'Export-Import Bank of Malaysia Berhad (Exim Bank)', text: 'Export-Import Bank of Malaysia Berhad (Exim Bank)' },
  { value: 'GX Bank', text: 'GX Bank' },
  { value: 'Hong Leong Bank Berhad', text: 'Hong Leong Bank Berhad' },
  { value: 'Hong Leong Islamic Bank Berhad', text: 'Hong Leong Islamic Bank Berhad' },
  { value: 'HSBC Amanah Malaysia Berhad', text: 'HSBC Amanah Malaysia Berhad' },
  { value: 'HSBC Bank Malaysia Berhad', text: 'HSBC Bank Malaysia Berhad' },
  { value: 'India International Bank (Malaysia) Berhad', text: 'India International Bank (Malaysia) Berhad' },
  { value: 'Industrial and Commercial Bank of China (Malaysia) Berhad', text: 'Industrial and Commercial Bank of China (Malaysia) Berhad' },
  { value: 'J.P. Morgan Chase Bank Berhad', text: 'J.P. Morgan Chase Bank Berhad' },
  { value: 'KAF Digital Bank', text: 'KAF Digital Bank' },
  { value: 'Kuwait Finance House (Malaysia) Berhad', text: 'Kuwait Finance House (Malaysia) Berhad' },
  { value: 'Malayan Banking Berhad', text: 'Malayan Banking Berhad' },
  { value: 'Maybank Islamic Berhad', text: 'Maybank Islamic Berhad' },
  { value: 'MBSB Bank Berhad', text: 'MBSB Bank Berhad' },
  { value: 'Mizuho Bank (Malaysia) Berhad', text: 'Mizuho Bank (Malaysia) Berhad' },
  { value: 'OCBC Al-Amin Bank Berhad', text: 'OCBC Al-Amin Bank Berhad' },
  { value: 'OCBC Bank (Malaysia) Berhad', text: 'OCBC Bank (Malaysia) Berhad' },
  { value: 'Public Bank Berhad', text: 'Public Bank Berhad' },
  { value: 'Public Islamic Bank Berhad', text: 'Public Islamic Bank Berhad' },
  { value: 'RHB Bank Berhad', text: 'RHB Bank Berhad' },
  { value: 'RHB Islamic Bank Berhad', text: 'RHB Islamic Bank Berhad' },
  { value: 'Ryt Bank', text: 'Ryt Bank' },
  { value: 'Sabah Development Bank Berhad (SDB)', text: 'Sabah Development Bank Berhad (SDB)' },
  { value: 'Standard Chartered Bank Malaysia Berhad', text: 'Standard Chartered Bank Malaysia Berhad' },
  { value: 'Standard Chartered Saadiq Berhad ', text: 'Standard Chartered Saadiq Berhad ' },
  { value: 'Sumitomo Mitsui Banking Corporation Malaysia Berhad', text: 'Sumitomo Mitsui Banking Corporation Malaysia Berhad' },
  { value: 'The Bank of Nova Scotia Berhad', text: 'The Bank of Nova Scotia Berhad' },
  { value: 'Touch \'n Go', text: 'Touch \'n Go' },
  { value: 'United Overseas Bank (Malaysia) Bhd.', text: 'United Overseas Bank (Malaysia) Bhd.' },
];

const SG_BANKS = [
  { value: 'Australia and New Zealand Banking Group Ltd', text: 'Australia & New Zealand Banking Group Ltd' },
  { value: 'Bangkok Bank Public Company Limited', text: 'Bangkok Bank Public Company Limited' },
  { value: 'Bank of America', text: 'Bank of America' },
  { value: 'Bank of China Limited', text: 'Bank of China Limited' },
  { value: 'Bank of East Asia Ltd', text: 'Bank of East Asia Ltd' },
  { value: 'Bank of India', text: 'Bank of India' },
  { value: 'Bank of Singapore Limited', text: 'Bank of Singapore Limited' },
  { value: 'Bank of Tokyo-Mitsubishi UFJ Ltd', text: 'Bank of Tokyo-Mitsubishi UFJ Ltd' },
  { value: 'BNP Paribas', text: 'BNP Paribas' },
  { value: 'CIMB Bank Berhad', text: 'CIMB Bank Berhad' },
  { value: 'Citibank Singapore Ltd', text: 'Citibank Singapore Ltd' },
  { value: 'Credit Agricole Corporate & Investment Bank', text: 'Credit Agricole Corporate & Investment Bank' },
  { value: 'DBS Bank Ltd', text: 'DBS Bank LTD' },
  { value: 'Far Eastern Bank Ltd', text: 'Far Eastern Bank LTD' },
  { value: 'HL Bank', text: 'HL Bank' },
  { value: 'Hongkong and Shanghai Banking Corporation Ltd', text: 'Hongkong & Shanghai Banking Corporation Ltd' },
  { value: 'Icici Bank Ltd', text: 'Icici Bank Ltd' },
  { value: 'Indian Bank', text: 'Indian Bank' },
  { value: 'Indian Overseas Bank', text: 'Indian Overseas Bank' },
  { value: 'Industrial and Commercial Bank of China Ltd', text: 'Industrial & Commercial Bank of China Ltd' },
  { value: 'JP Morgan Chase Bank', text: 'JP Morgan Chase Bank' },
  { value: 'Malayan Banking Berhad', text: 'Malayan Banking Berhad' },
  { value: 'Mizuho Bank Ltd', text: 'Mizuho Bank Ltd' },
  { value: 'Oversa-Chinese Banking Corporation Limited', text: 'Oversa-Chinese Banking Corporation Limited' },
  { value: 'PT Bank negara Indonesia (Persero) Tbk', text: 'PT Bank negara Indonesia (Persero) Tbk' },
  { value: 'RHB Bank Berhad', text: 'RHB Bank Berhad' },
  { value: 'Standard Chartered Bank (Singapore) Ltd', text: 'Standard Chartered Bank (Singapore) Ltd' },
  { value: 'State Bank of India', text: 'State Bank of India' },
  { value: 'Sumitomo Mitsui Banking Corporation', text: 'Sumitomo Mitsui Banking Corporation' },
  { value: 'UCO Bank', text: 'UCO Bank' },
  { value: 'United Overseas Bank Limited', text: 'United Overseas Bank Limited' },
];

export const ID_BANKS = [
  { value: 'PT Bank Anz Indonesia', text: 'PT Bank Anz Indonesia' },
  { value: 'PT Bank Artha Graha Internasional Tbk', text: 'PT Bank Artha Graha Internasional Tbk' },
  { value: 'PT Bank Bnp Paribas Indonesia', text: 'PT Bank Bnp Paribas Indonesia' },
  { value: 'PT Bank Btpn Tbk', text: 'PT Bank Btpn Tbk' },
  { value: 'PT Bank Bumi Arta Tbk', text: 'PT Bank Bumi Arta Tbk' },
  { value: 'PT Bank Capital Indonesia Tbk', text: 'PT Bank Capital Indonesia Tbk' },
  { value: 'PT Bank Central Asia Tbk', text: 'PT Bank Central Asia Tbk' },
  { value: 'PT Bank Cimb Niaga Tbk', text: 'PT Bank Cimb Niaga Tbk' },
  { value: 'PT Bank Commonwealth', text: 'PT Bank Commonwealth' },
  { value: 'PT Bank Ctbc Indonesia', text: 'PT Bank Ctbc Indonesia' },
  { value: 'PT Bank Danamon Indonesia Tbk', text: 'PT Bank Danamon Indonesia Tbk' },
  { value: 'PT Bank Dbs Indonesia', text: 'PT Bank Dbs Indonesia' },
  { value: 'PT Bank Hsbc Indonesia', text: 'PT Bank Hsbc Indonesia' },
  { value: 'PT Bank Icbc Indonesia', text: 'PT Bank Icbc Indonesia' },
  { value: 'PT Bank Jtrust Indonesia Tbk', text: 'PT Bank Jtrust Indonesia Tbk' },
  { value: 'PT Bank Kb Bukopin Tbk', text: 'PT Bank Kb Bukopin Tbk' },
  { value: 'PT Bank Keb Hana Indonesia', text: 'PT Bank Keb Hana Indonesia' },
  { value: 'PT Bank Mandiri (Persero) Tbk', text: 'PT Bank Mandiri (Persero) Tbk' },
  { value: 'PT Bank Mayapada International Tbk', text: 'PT Bank Mayapada International Tbk' },
  { value: 'PT Bank Maybank Indonesia Tbk', text: 'PT Bank Maybank Indonesia Tbk' },
  { value: 'PT Bank Mega Syariah', text: 'PT Bank Mega Syariah' },
  { value: 'PT Bank Mega Tbk', text: 'PT Bank Mega Tbk' },
  { value: 'PT Bank Muamalat Indonesia Tbk', text: 'PT Bank Muamalat Indonesia Tbk' },
  { value: 'PT Bank Negara Indonesia (Persero) Tbk', text: 'PT Bank Negara Indonesia (Persero) Tbk' },
  { value: 'PT Bank Ocbc Nisp Tbk', text: 'PT Bank Ocbc Nisp Tbk' },
  { value: 'PT Bank Permata Tbk', text: 'PT Bank Permata Tbk' },
  { value: 'PT Bank Rakyat Indonesia (Persero) Tbk', text: 'PT Bank Rakyat Indonesia (Persero) Tbk' },
  { value: 'PT Bank Sbi Indonesia', text: 'PT Bank Sbi Indonesia' },
  { value: 'PT Bank Sinarmas Tbk', text: 'PT Bank Sinarmas Tbk' },
  { value: 'PT Bank Syariah Indonesia Tbk', text: 'PT Bank Syariah Indonesia Tbk' },
  { value: 'PT Bank Tabungan Negara (Persero) Tbk', text: 'PT Bank Tabungan Negara (Persero) Tbk' },
  { value: 'PT Bank Uob Indonesia', text: 'PT Bank Uob Indonesia' },
  { value: 'PT Bank Victoria Syariah', text: 'PT Bank Victoria Syariah' },
  { value: 'VA - PT Bank Central Asia Tbk', text: 'VA - PT Bank Central Asia Tbk' },
  { value: 'VA - PT Bank Mandiri (Persero) Tbk', text: 'VA - PT Bank Mandiri (Persero) Tbk' },
  { value: 'VA - PT Bank Negara Indonesia (Persero) Tbk', text: 'VA - PT Bank Negara Indonesia (Persero) Tbk' },
  { value: 'VA - PT Bank Permata Tbk', text: 'VA - PT Bank Permata Tbk' },
  { value: 'VA - PT Bank Rakyat Indonesia (Persero) Tbk', text: 'VA - PT Bank Rakyat Indonesia (Persero) Tbk' },
  { value: 'VA - PT Bank Syariah Indonesia Tbk', text: 'VA - PT Bank Syariah Indonesia Tbk' },
];

export const VN_BANKS = [
  { value: 'Vietcombank', text: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' },
  { value: 'Agribank', text: 'Vietnam Bank for Agriculture and Rural Development' },
  { value: 'BIDV', text: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
  { value: 'VietinBank', text: 'Vietnam Joint Stock Commercial Bank for Industry and Trade' },
  { value: 'Techcombank', text: 'Vietnam Technological and Commercial Joint-stock Bank' },
  { value: 'MB Bank', text: 'Military Commercial Joint Stock Bank' },
  { value: 'VPBank', text: 'Vietnam Prosperity Joint Stock Commercial Bank' },
  { value: 'ACB', text: 'Asia Commercial Joint Stock Bank' },
  { value: 'Sacombank', text: 'Saigon Thuong Tin Commercial Joint Stock Bank' },
  { value: 'VIB', text: 'Vietnam International Commercial Joint Stock Bank' },
  { value: 'HDBank', text: 'Ho Chi Minh City Development Joint Stock Commercial Bank' },
  { value: 'TPBank', text: 'Tien Phong Commercial Joint Stock Bank' },
  { value: 'SHB', text: 'Saigon - Hanoi Commercial Joint Stock Bank' },
  { value: 'Shinhan Bank Vietnam', text: 'Shinhan Bank Vietnam' },
  { value: 'HSBC Vietnam', text: 'HSBC Vietnam' },
  { value: 'Standard Chartered Vietnam', text: 'Standard Chartered Vietnam' },
  { value: 'Public Bank Vietnam', text: 'Public Bank Vietnam' },
  { value: 'UOB Vietnam', text: 'UOB Vietnam' },
  { value: 'Woori Bank', text: 'Woori Bank' }
];

export const BANKS = [
  ...MY_BANKS,
  ...ID_BANKS,
  ...SG_BANKS,
];

const BANKS_BY_COUNTRY = [
  { country: 'id', value: ID_BANKS },
  { country: 'my', value: MY_BANKS },
  { country: 'sg', value: SG_BANKS },
  { country: 'vn', value: VN_BANKS },
];

export default BANKS_BY_COUNTRY;



// WEBPACK FOOTER //
// ./src/constants/banks.js